import Text from "theme/Text";
import _ from 'lodash';
import React from "react";
import { StyleSheet, View } from "react-native";
import { viewportAwareListItem } from "components/atoms/viewportaware/ListItem";
import { constantsActive } from "utils/constants/constants";
import Tag, { tagAppearances } from "components/atoms/Tag";
import i18n from "utils/i18n";
import { colorList } from 'utils/colors'
import HelperString from 'utils/helper-string'
import { ListItemStyles } from 'styles/components/atoms/ListItem'
import ThemedPressable from 'components/atoms/ThemedPressable'
import isEqual from 'react-fast-compare'
import HelperDate from 'utils/helper-date'
import { layoutStyles } from "styles/layout";

const ListItem = ( { title = null, subtitle = null, time = null, item = {}, onPress = undefined, subtitleProps = {}, accessoryRight = undefined, accessoryLeft = undefined, accessoryLeftSize = 'auto', style = {}, title_add_active_tag = false, drag = false, dragIsActive = false, children = undefined } = {} ) => {
	
	const dynamicDraggableStyle = {
		position: 'absolute',
		width: '100%',
		height: '100%',
		backgroundColor: dragIsActive ? colorList.PRIMARY.primary : 'transparent',
		opacity: 0.3
	};
	
	const accessoryLeftStyle = [
		ListItemStyles.colAccessoryLeft,
		{
			width: accessoryLeftSize,
			minWidth: accessoryLeftSize
		}
	]
	
	// Get the time formatted
	let formattedTime = null;
	if( time ) {
		const timeObject = HelperDate.date( time );
		let timeFormat = 'DD-MM-YYYY';
		
		switch( true ) {
			// Today
			case HelperDate.fn.isToday( timeObject ):
				timeFormat = 'HH:mm';
				break;
				
			case timeObject.isAfter( HelperDate.date().subtract(1, 'week'), 'day' ):
				timeFormat = 'dddd';
				break;
		}
		
		formattedTime = timeObject.format( timeFormat )
	}

	// Render the content
	const content = (
		<View
			style={[ styles.container, style ]}>
			
			{ title_add_active_tag && (
				<View
					style={ ListItemStyles.colActiveTag }>

					{ item.active === constantsActive.YES && (
						<Tag appearance={tagAppearances.GREEN}>{i18n.t( 'management:generic.active.yes')}</Tag>
					)}
					
					{ item.active === constantsActive.NO && (
						<Tag appearance={tagAppearances.RED}>{i18n.t( 'management:generic.active.no')}</Tag>
					)}
				</View>
			)}
			
			{accessoryLeft && (
				<View
					style={ accessoryLeftSize !== 'auto' ? accessoryLeftStyle : ListItemStyles.colAccessoryLeft }>
					
					{ accessoryLeft }
				</View>
			)}
		
			<View
				style={ styles.textContainer }>
				
				{/* Top row */}
				<View
					style={ styles.titleContainer }>

					{ title && (
						<Text
							category={"s1"}>
							
							{ title }
						</Text>
					)}
					
					{ formattedTime && (
						<Text
							appearance={"hint"}
							category={"c2"}>

							{ formattedTime }
						</Text>
					)}
				</View>

				{/* Bottom row */}
				{ subtitle && (
					<Text
						{ ...subtitleProps }
						appearance={'hint'}
						category={"c1"}>
						
						{ subtitle }
					</Text>
				)}

				{ children }
			</View>
			
			{ accessoryRight && (
				<View 
					style={ ListItemStyles.colAccessoryRight }>
					
					{ accessoryRight }
				</View>
			)}
		</View>
	);
	
	const result = viewportAwareListItem({
		key: HelperString.hash( 'list-item-create', item ),
		onPress: onPress ? () => {
			return onPress(item);
		} : null,
		children: content
	});
	
	if( drag !== false && _.isFunction( drag ) ) {
		return (
			<ThemedPressable
				onPress={ drag }
				onPressIn={ drag }
				onLongPress={ drag }>
				
				{ result }
				
				<View
					style={ dynamicDraggableStyle }
				/>
			</ThemedPressable>
		)
	}
	
	return result;
}

const styles = StyleSheet.create({
	container: {
		flexDirection: 'row',
	},
	textContainer: {
		// ...layoutStyles.flexUnset,
		flexDirection: 'column',
		justifyContent: 'center',
		flex: 1,
	},
	titleContainer: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	}
})

export default React.memo( ListItem, isEqual );
